module.exports = __webpack_public_path__ + "img/HappyCouple.9036cd0d.jpeg";